export default __webpack_public_path__ + "static/media/course-4.f170a8f4.jpg";